export default "__VITE_ASSET__X_XtC1aM__"